(function () {
  function initFeaturedCollectionSwipers() {
    document.querySelectorAll(".js-featured-collection-swiper").forEach(function (section) {
      var el = section.querySelector(".js-fcs-swiper");
      if (!el || el.dataset.fcsInitialized) return;
      el.dataset.fcsInitialized = "true";

      var prev = section.querySelector(".js-fcs-arrow-prev");
      var next = section.querySelector(".js-fcs-arrow-next");

      new Swiper(el, {
        slidesPerView: 1.3,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        breakpoints: {
          550: { slidesPerView: 2, spaceBetween: 16 },
          750: { slidesPerView: 2.4, spaceBetween: 20 },
          990: { slidesPerView: 3, spaceBetween: 24 },
          1200: { slidesPerView: 4, spaceBetween: 24 },
        },
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initFeaturedCollectionSwipers);
  document.addEventListener("shopify:section:load", initFeaturedCollectionSwipers);
})();